import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, Button, Paper, Typography } from '@mui/material';
import { alpha, useTheme } from '@mui/material/styles';
import { Link as RouterLink, useNavigate, useParams, useSearchParams } from 'react-router-dom';
import NavBar from '../NavBar/NavBar';
import SystemBannerFromGrid from '../../LandingHero/SystemBannerFromGrid';
/**
 * Placeholder route for individual agency profiles linked from the landing page.
 * Replace with full agency CMS page when ready.
 */
const AgencyPlaceholderPage = ({ nav, intro = 'Permits, licenses, and services for this agency will be listed here. This page is under construction.', systemBanner, }) => {
    const theme = useTheme();
    const navigate = useNavigate();
    const { recordId } = useParams();
    const [searchParams] = useSearchParams();
    const rawName = searchParams.get('name')?.trim();
    const name = rawName || 'Agency';
    const goHomeAndScrollAgencies = () => {
        void navigate('/');
        window.setTimeout(() => {
            document.getElementById('agencies')?.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }, 80);
    };
    return (_jsxs(Box, { component: "main", sx: {
            minHeight: '100vh',
            display: 'flex',
            flexDirection: 'column',
            bgcolor: alpha(theme.palette.primary.dark, 0.04),
        }, children: [nav ? (_jsx(Box, { sx: { width: '100%', bgcolor: '#fff', borderBottom: '1px solid', borderColor: 'divider' }, children: _jsx(NavBar, { ...nav }) })) : null, systemBanner ? _jsx(SystemBannerFromGrid, { ...systemBanner, agencyName: rawName }) : null, _jsx(Box, { sx: {
                    flex: 1,
                    width: '100%',
                    maxWidth: 720,
                    mx: 'auto',
                    px: { xs: 2, sm: 3 },
                    py: { xs: 4, md: 6 },
                }, children: _jsxs(Paper, { elevation: 0, sx: {
                        p: { xs: 3, md: 4 },
                        borderRadius: 2,
                        border: '1px solid',
                        borderColor: alpha(theme.palette.primary.main, 0.12),
                        boxShadow: '0 8px 32px rgba(15, 23, 42, 0.08)',
                        bgcolor: '#fff',
                    }, children: [_jsx(Typography, { variant: "overline", sx: { color: 'secondary.main', fontWeight: 700, letterSpacing: '0.12em', display: 'block', mb: 1 }, children: "Agency" }), _jsx(Typography, { variant: "h4", component: "h1", sx: { fontWeight: 700, color: 'primary.dark', mb: 1, lineHeight: 1.25 }, children: name }), recordId ? (_jsxs(Typography, { variant: "caption", sx: { color: 'text.secondary', display: 'block', mb: 2 }, children: ["Record ID: ", recordId] })) : null, _jsx(Typography, { variant: "body1", sx: { color: 'text.secondary', lineHeight: 1.65, mb: 3 }, children: intro }), _jsxs(Box, { sx: { display: 'flex', flexWrap: 'wrap', gap: 1.5 }, children: [_jsx(Button, { component: RouterLink, to: "/", variant: "contained", color: "secondary", children: "Back to Home" }), _jsx(Button, { type: "button", variant: "outlined", color: "primary", onClick: goHomeAndScrollAgencies, children: "View all agencies" })] })] }) })] }));
};
export default AgencyPlaceholderPage;
